import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Slide from '@material-ui/core/Slide';
import  { withStyles } from '@material-ui/core/styles';
import { compose } from "recompose";

const styles = theme => ({
    container: {
      backgroundColor: theme.ModalBGColor,
    },
    title: {
      color: theme.HeaderSelectedText,
    },
    contentRoot:{
      paddingBottom:12
    },
    content: {
      color: theme.TextColor,
      fontSize: theme.textFontSize,
    },
    normalButton: {
      textTransform : "none",
      borderColor:theme.HeaderSelectedText,
      color: theme.HeaderSelectedText,
      '&:hover':{
        borderColor:theme.HeaderSelectedText,
      }
    },
    focusButton:{
      textTransform : "none",
      borderColor: theme.HeaderSelectedText,
      backgroundColor: theme.HeaderSelectedText,
      color: "white",
      '&:hover':{
        backgroundColor: theme.HeaderSelectedText,
      }
    }
});

const ModalDialog = props => (
    <Dialog
    disableBackdropClick
    disableEscapeKeyDown
    TransitionComponent={(props)=><Slide direction="down" {...props}/>}
    open={true}
    onClose={()=>props.onClose(false)}
    aria-labelledby="responsive-dialog-title"
    classes={{paper: props.classes.container}}
    {...props.dialogProps}
  >
    <DialogTitle id="responsive-dialog-title" classes={{root:props.classes.title}} disableTypography {...props.titleProps}>{props.title}</DialogTitle>
    <DialogContent classes={{root: props.classes.contentRoot}} {...props.contentProps}>
      <DialogContentText className={props.classes.content} {...props.contentTextProps}>
        {props.children}
      </DialogContentText>
    </DialogContent>
    <DialogActions {...props.dialogActionsProps}>
      <Button variant="outlined" size="small" onClick={()=>props.onClose(false)} color="primary" className={props.classes.normalButton} {...props.buttonProps}>
        {props.discardLabel || "No"}
      </Button>
      <Button variant="contained" size="small" onClick={()=>props.onClose(true)} color="primary" autoFocus className={props.classes.focusButton} {...props.buttonProps}>
        {props.confirmLabel || "Yes"}
      </Button>
    </DialogActions>
  </Dialog>
);

ModalDialog.defaultProps = {
  dialogProps: {},
  titleProps:{},
  contentProps:{},
  contentTextProps:{},
  dialogActionsProps:{},
  buttonProps:{}
}

export default compose(withMobileDialog() ,withStyles(styles))(ModalDialog);